// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.step-indicator {
  width: 80%;
  margin-left: 10%;
}

.main-div {
  margin-left: 12.25%;
  margin-right: 12.25%;
  margin-top: 20px;
  margin-bottom: 20px;
}

@media (max-width: 500px) {
  .main-div {
    width: 93%;
    margin-left: 10px;
  }
}
.review-heading {
  width: 100%;
  font-weight: bold;
  color: #000000;
  opacity: 1;
  float: left;
  margin-bottom: 15px !important;
  padding-top: 5px;
}
@media (max-width: 1024px) {
  .review-heading {
    font-size: 20px;
    margin-top: -10px;
  }
}

.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.flex-item {
  padding: 5px;
  width: 600px;
  min-width: 320px;
}

.submitting {
  height: 50px;
  margin-left: 45%;
  width: 50px;
}

#error-main-container, #flex-container-spinner {
  width: 78%;
  margin-left: 11%;
}

.review-info {
  width: 100%;
  float: left;
  padding-left: 25px;
  margin-bottom: 20px;
  margin-top: 20px;
}
@media (max-width: 1024px) {
  .review-info {
    width: 340px !important;
    padding-left: 0px;
  }
}
@media only screen and (max-width: 1020px) and (min-width: 500px) {
  .review-info {
    width: 660px !important;
  }
}

.review-blocks {
  display: inline-grid;
  margin-right: 8%;
}
@media (max-width: 1024px) {
  .review-blocks {
    margin-right: 23px;
    width: 90px;
  }
}

.review-block-heading {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  text-align: left;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .review-block-heading {
    width: 90px;
  }
}

.review-block-value {
  color: #000000;
  opacity: 1;
  text-align: left;
}
@media (max-width: 1024px) {
  .review-block-value {
    width: 200px;
    font-size: 14px;
  }
}

.product-heading {
  margin-top: 2%;
  margin-bottom: 2%;
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.product-section {
  width: 100%;
}

.added-links {
  display: inline-block;
}

.prod-field {
  margin-bottom: 10px;
}

.product-fields {
  margin-bottom: 10px;
  width: 45%;
}
@media (max-width: 1024px) {
  .product-fields {
    width: 210px;
  }
}

.ctn-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.notification-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.notification-section, .ctn-section {
  margin-top: 2%;
}

.notification-type {
  width: 280px;
}

.ctn-file-name {
  width: 40%;
}

.acknowledgement-sub-section {
  display: flexbox;
  background-color: #f2f2f2;
}

.acknowledgement-section {
  background-color: transparent;
}

.acknowledgement-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  padding: 15px 15px 15px 15px;
  margin-bottom: 0px;
}

.acknowledgement-description {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  padding: 5px 15px 5px 15px;
  margin-bottom: 0px;
}

.confirm-section {
  padding: 15px 15px 15px 0px;
}

.terms-section {
  margin-bottom: 20px !important;
}

.terms-heading {
  font-size: 16px;
  margin-bottom: 12px;
}

.terms-description {
  font-size: 16px;
  margin-bottom: 16px;
}

.terms-link-box {
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  padding: 9px;
  margin-bottom: 12px;
}

.terms-link-box a {
  text-decoration: underline;
}

#finishEnrollment {
  float: right;
  font-size: 16px;
}

a {
  color: #1483d9;
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

#cancel-link {
  margin-right: 20px;
  font-size: 16px;
}

.labels-inline {
  display: inline-block;
}

.changeLink {
  margin-left: 30px;
}

.tooltipActive + .helper-text {
  display: block;
  width: 300px;
  bottom: 130%;
  margin-left: -125px;
  text-align: center !important;
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 90px !important;
    height: 145px;
    margin-left: -30px !important;
  }
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 100px !important;
    margin-left: -60px;
  }
}

.inline-labels {
  display: inline-block;
}

.tooltip-input {
  right: -115px;
  position: relative !important;
  bottom: -15px;
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -55px;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .tooltip-input {
    right: -60px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .tooltip-input {
    right: -55px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -5px;
    bottom: -15px;
    width: 20px;
  }
}

ul.errorDescr {
  list-style-type: disc !important;
}

.errorDescr li {
  margin-left: 20px !important;
}

.marginBottomZero {
  margin-bottom: 0px !important;
}

.showMore {
  cursor: pointer;
  color: #fff;
  float: right;
  font-size: 14px;
}

.model-box-loginModal {
  border-radius: 8px;
  animation: animatetop 0.4s;
  background: white;
  margin: 0 auto;
  max-height: 90%;
  max-width: 620px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  top: 10%;
  box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);
  padding: 32px 32px 32px 32px;
  width: 360px;
}

.modal-header-loginModal {
  padding: 0px !important;
  position: relative;
}

.model-cover {
  background: rgba(0, 0, 0, 0.7);
}

.confirmation-span {
  font-size: 15px;
  text-align: center;
  margin-bottom: 24px;
}

.continue-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.confirm-msg {
  font-size: 15px;
  margin-bottom: 24px;
  font-weight: 100;
  text-align: left;
}

.continue-btn {
  font-size: 15px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modalHeading {
  color: hsl(204.9, 94.4%, 35.1%);
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
}

.continue-btn {
  color: #fff;
  border-radius: 42px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--Controls-Button-Primary-Fill, #00388F);
}
@media (max-width: 1024px) {
  .continue-btn {
    width: 100px !important;
    margin-right: 10px !important;
  }
}

.continue-btn:disabled,
.continue-btn[disabled] {
  background: #c1c7cd;
  color: #6a6a6a;
  cursor: not-allowed;
}

.back-btn {
  min-width: 100px;
  height: 32px;
  opacity: 1;
  gap: 10px;
  border-radius: 48px;
  border-width: 2px;
  padding-top: 8px;
  padding-right: 24px;
  padding-bottom: 8px;
  padding-left: 24px;
  border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);
  background: #F1F2F3 0% 0% no-repeat padding-box !important;
  color: var(--Controls-Button-Secondary-Text-icon, #00388F);
  display: flex;
  justify-content: center;
  align-items: center;
}

.legal-section, .terms-section {
  margin-top: -10px;
}

.submit-section {
  padding-top: 15px;
}

@media (max-width: 1024px) {
  .review-page {
    margin-left: -20px !important;
    margin-top: -45px !important;
  }
}
@media (max-width: 1024px) {
  .msg-box {
    margin-top: 10px;
    margin-left: -35px;
    width: 325px;
    font-size: 16px;
  }
}

@media (max-width: 1024px) {
  hr {
    margin-left: -2px !important;
    border: 1px solid #979797;
    width: 266px;
  }
}
.review-info-new {
  align-items: flex-start;
  display: flex;
  max-width: 100%;
}

.review-info-new .review-block-value {
  margin-top: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup-setup/review-signup-setup/review-signup-setup.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACI,UAAA;EACA,gBAAA;AAoJJ;;AAlJA;EACI,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAqJJ;;AAnJA;EACI;IAEI,UAAA;IACA,iBAAA;EAqJN;AACF;AAlJA;EAEI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AAmJJ;AAlJI;EATJ;IAUQ,eAAA;IACA,iBAAA;EAqJN;AACF;;AAnJA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAsJJ;;AAnJE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAsJJ;;AAnJE;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AAsJJ;;AApJE;EACI,UAAA;EACA,gBAAA;AAuJN;;AArJA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAwJJ;AF5LI;EE+BJ;IAOQ,uBAAA;IACA,iBAAA;EA0JN;AACF;AAzJI;EAVJ;IAYc,uBAAA;EA2JZ;AACF;;AAzJA;EAEI,oBAAA;EACA,gBAAA;AA2JJ;AF5MI;EE8CJ;IAKQ,kBAAA;IACA,WAAA;EA6JN;AACF;;AA3JA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AA8JJ;AF1NI;EEuDJ;IAOQ,WAAA;EAgKN;AACF;;AA9JA;EAEI,cAAA;EACA,UAAA;EACA,gBAAA;AAgKJ;AFrOI;EEiEJ;IAMQ,YAAA;IACA,eAAA;EAkKN;AACF;;AAhKA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAmKJ;;AAjKA;EACI,WAAA;AAoKJ;;AAlKA;EACI,qBAAA;AAqKJ;;AAlKA;EACI,mBAAA;AAqKJ;;AAnKA;EACI,mBAAA;EACA,UAAA;AAsKJ;AFrQI;EE6FJ;IAKQ,YAAA;EAuKN;AACF;;AApKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAuKJ;;AArKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAwKJ;;AAtKA;EACI,cAAA;AAyKJ;;AAvKA;EACI,YAAA;AA0KJ;;AAxKA;EACI,UAAA;AA2KJ;;AAzKA;EACI,gBAAA;EACA,yBAAA;AA4KJ;;AA1KA;EACI,6BAAA;AA6KJ;;AA3KA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,4BAAA;EACA,kBAAA;AA8KJ;;AA5KA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,0BAAA;EACA,kBAAA;AA+KJ;;AA7KA;EACI,2BAAA;AAgLJ;;AA9KA;EACI,8BAAA;AAiLJ;;AA/KA;EACI,eAAA;EACA,mBAAA;AAkLJ;;AAhLA;EACI,eAAA;EACA,mBAAA;AAmLJ;;AAjLA;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAoLJ;;AAlLA;EACI,0BAAA;AAqLJ;;AAnLA;EACI,YAAA;EACA,eAAA;AAsLJ;;AApLA;EACI,cAAA;EACA,eAAA;AAuLJ;;AArLA;EACI,0BAAA;AAwLJ;;AArLA;EAEI,kBAAA;EAEA,eAAA;AAsLJ;;AAhLA;EACI,qBAAA;AAmLJ;;AAhLA;EACI,iBAAA;AAmLJ;;AAhLA;EACI,cAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AAmLJ;AF9XI;EEsMJ;IAQQ,sBAAA;IACA,aAAA;IACA,6BAAA;EAoLN;AACF;AAlLI;EAbJ;IAcQ,uBAAA;IACA,kBAAA;EAqLN;AACF;;AAlLA;EACM,qBAAA;AAqLN;;AAlLA;EACI,aAAA;EACA,6BAAA;EACA,aAAA;AAqLJ;AFrZI;EE6NJ;IAMQ,YAAA;IACA,YAAA;IACA,WAAA;EAsLN;AACF;AArLI;EAVJ;IAWQ,uBAAA;IACA,YAAA;IACA,WAAA;EAwLN;AACF;AAvLM;EAfN;IAgBQ,uBAAA;IACA,YAAA;IACA,WAAA;EA0LN;AACF;AAxLM;EArBN;IAsBQ,WAAA;IACA,aAAA;IACA,WAAA;EA2LN;AACF;;AAxLA;EACI,gCAAA;AA2LJ;;AAxLA;EACI,4BAAA;AA2LJ;;AAxLA;EACI,6BAAA;AA2LJ;;AAxLA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA2LJ;;AAxLA;EACI,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,0CAAA;EACA,4BAAA;EACA,YAAA;AA2LJ;;AAxLA;EACI,uBAAA;EACA,kBAAA;AA2LJ;;AAxLA;EACI,8BAAA;AA2LJ;;AAxLA;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;AA2LJ;;AAxLA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA2LJ;;AAxLA;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AA2LJ;;AAvLA;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA0LJ;;AAvLA;EACI,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA0LJ;;AAvLA;EACI,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wDAAA;AA0LJ;AF3gBI;EE0UJ;IASM,uBAAA;IACA,6BAAA;EA4LJ;AACF;;AAxLE;;EAEE,mBAAA;EACA,cAAA;EACA,mBAAA;AA2LJ;;AAvLE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kEAAA;EACA,0DAAA;EACA,0DAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA0LJ;;AAvLE;EACE,iBAAA;AA0LJ;;AAvLE;EACE,iBAAA;AA0LJ;;AFnjBI;EE6XA;IACI,6BAAA;IACA,4BAAA;EA0LN;AACF;AF1jBI;EEkZJ;IAEQ,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,eAAA;EA0KN;AACF;;AFlkBI;EE6ZA;IACI,4BAAA;IACA,yBAAA;IACA,YAAA;EAyKN;AACF;AAtKA;EAEI,uBAAA;EACA,aAAA;EACA,eAAA;AAuKJ;;AApKA;EACI,0BAAA;AAuKJ","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.step-indicator {\n    width: 80%;\n    margin-left: 10%;\n}\n.main-div {\n    margin-left: 12.25%;\n    margin-right: 12.25%;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n@media(max-width: 500px) {\n    .main-div {\n        //width: 70%;\n        width: 93%;//335px;\n        margin-left: 10px;\n        //margin-right: 10px !important;\n    }\n}\n.review-heading {\n    // font-size: 32px;\n    width: 100%;\n    font-weight: bold;\n    color: #000000;\n    opacity: 1;\n    float: left;\n    margin-bottom: 15px !important;\n    padding-top: 5px;\n    @media(max-width: 1024px) {\n        font-size: 20px;\n        margin-top: -10px;\n    }\n}\n.flex-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n  }\n  \n  .flex-item {\n    padding: 5px;\n    width: 600px;\n    min-width: 320px;\n  }\n  \n  .submitting {\n    height: 50px;\n    margin-left: 45%;\n    width: 50px;\n  }\n  #error-main-container, #flex-container-spinner {\n      width: 78%;\n      margin-left: 11%;\n  }\n.review-info {\n    width: 100%;\n    float: left;\n    padding-left: 25px;\n    margin-bottom: 20px;\n    margin-top: 20px;\n    @include respond-to('small'){\n        width: 340px !important;\n        padding-left: 0px;\n    }\n    @media only screen and\n          (max-width: 1020px) and (min-width:500px) {\n              width: 660px !important;\n       }\n}\n.review-blocks {\n    // display: inline-block;\n    display: inline-grid;\n    margin-right: 8%;\n    @include respond-to('small'){\n        margin-right: 23px;\n        width: 90px;\n    }\n}\n.review-block-heading {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n    font-weight: bold;\n    @include respond-to('small'){\n        width:90px;\n    }\n}\n.review-block-value {\n    // font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n    @include respond-to('small'){\n        width: 200px;\n        font-size: 14px;\n    }\n}\n.product-heading {\n    margin-top: 2%;\n    margin-bottom: 2%;\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.product-section {\n    width: 100%;\n}\n.added-links {\n    display: inline-block;\n    // width: 40%;\n}\n.prod-field {\n    margin-bottom: 10px;\n}\n.product-fields {\n    margin-bottom: 10px;\n    width: 45%;\n\n    @include respond-to('small') {\n        width: 210px;\n    }\n    \n}\n.ctn-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.notification-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.notification-section, .ctn-section {\n    margin-top: 2%;\n}\n.notification-type {\n    width: 280px;\n}\n.ctn-file-name {\n    width: 40%;\n}\n.acknowledgement-sub-section {\n    display: flexbox;\n    background-color: #f2f2f2;\n}\n.acknowledgement-section {\n    background-color: transparent;\n}\n.acknowledgement-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    padding: 15px 15px 15px 15px;\n    margin-bottom: 0px;\n}\n.acknowledgement-description {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    padding: 5px 15px 5px 15px;\n    margin-bottom: 0px;\n}\n.confirm-section {\n    padding: 15px 15px 15px 0px;\n}\n.terms-section {\n    margin-bottom: 20px !important;\n}\n.terms-heading {\n    font-size: 16px;\n    margin-bottom: 12px;\n}\n.terms-description {\n    font-size: 16px;\n    margin-bottom: 16px;\n}\n.terms-link-box {\n    background: #ffffff;\n    border: 1px solid #cdcdcd;\n    border-radius: 5px;\n    padding: 9px;\n    margin-bottom: 12px;\n}\n.terms-link-box a {\n    text-decoration: underline;\n}\n#finishEnrollment {\n    float: right;\n    font-size: 16px;\n}\na {\n    color: #1483d9;\n    cursor: pointer;\n}\na:hover {\n    text-decoration: underline;\n}\n\n#cancel-link {\n    // float: right;\n    margin-right: 20px;\n    // margin-top: 15px;\n    font-size: 16px;\n}\n\n.submit-section {\n    // height: 50px;\n}\n.labels-inline {\n    display: inline-block;\n}\n\n.changeLink {\n    margin-left: 30px;\n}\n\n.tooltipActive + .helper-text {\n    display: block;\n    width: 300px;\n    bottom: 130%;\n    margin-left: -125px;\n    text-align: center !important;\n    //position: relative !important;\n    @include respond-to('small') {\n        width: 90px !important;\n        height: 145px;\n        margin-left: -30px !important;\n    }\n\n    @media(max-width: 1024px) {\n        width: 100px !important;\n        margin-left: -60px;\n    }\n}\n  \n.inline-labels {\n      display: inline-block;\n}\n\n.tooltip-input {\n    right: -115px;\n    position: relative !important;\n    bottom: -15px;\n\n    @include respond-to('small') {\n        right: -55px;\n        bottom: -5px;\n        width: 20px;\n    }\n    @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n        right: -60px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n      @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n        right: -55px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n\n      @media(max-width: 1024px) {\n        right: -5px;\n        bottom: -15px;\n        width: 20px;\n    }\n}\n\nul.errorDescr{\n    list-style-type: disc !important;\n}\n\n.errorDescr li{\n    margin-left: 20px !important;\n}\n\n.marginBottomZero{\n    margin-bottom: 0px !important;\n}\n\n.showMore {\n    cursor: pointer;\n    color: #fff;\n    float: right;\n    font-size: 14px;\n}\n\n.model-box-loginModal{\n    border-radius: 8px;\n    animation: animatetop 0.4s;\n    background: white;\n    margin: 0 auto;\n    max-height: 90%;\n    max-width: 620px;\n    overflow: auto;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    top: 10%;\n    box-shadow: 0 3px 8px 3px rgba(0, 0, 0, 0);\n    padding: 32px 32px 32px 32px;\n    width: 360px;\n}\n\n.modal-header-loginModal{\n    padding: 0px !important;\n    position: relative;\n  }\n\n.model-cover {\n    background: rgba(0, 0, 0, 0.7);;\n}\n\n.confirmation-span {\n    font-size: 15px;\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.continue-div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n\n.confirm-msg {\n    font-size: 15px; \n    margin-bottom: 24px; \n    font-weight: 100; \n    text-align: left;\n}\n\n\n.continue-btn {\n    font-size: 15px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.modalHeading {\n    color: hsl(204.9, 94.4%, 35.1%);\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.continue-btn {\n    color:#fff;\n    border-radius: 42px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--Controls-Button-Primary-Fill, #00388F);\n    @include respond-to('small') {\n      width: 100px !important;\n      margin-right: 10px !important;\n    }\n  }\n\n  // local background above beats the global .btn-secondary:disabled rule, so restate it here\n  .continue-btn:disabled,\n  .continue-btn[disabled] {\n    background: #c1c7cd;\n    color: #6a6a6a;\n    cursor: not-allowed;\n  }\n\n\n  .back-btn {\n    min-width: 100px;\n    height: 32px;\n    opacity: 1;\n    gap: 10px;\n    border-radius: 48px;\n    border-width: 2px;\n    padding-top: 8px;\n    padding-right: 24px;\n    padding-bottom: 8px;\n    padding-left: 24px;\n    border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);\n    background: #F1F2F3 0% 0% no-repeat padding-box !important;\n    color: var(--Controls-Button-Secondary-Text-icon, #00388F);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .legal-section, .terms-section {\n    margin-top: -10px;\n  }\n\n  .submit-section {\n    padding-top: 15px;\n  }\n\n  @include respond-to('small') {\n    .review-page {\n        margin-left: -20px !important;\n        margin-top: -45px !important;\n      }\n  }\n  \n\n// i.tooltip-icon {\n//     position: relative !important;\n//     margin-left: 5px !important;\n\n//     @include respond-to('small') {\n//         position: relative !important;\n//         margin-left: -65px !important;\n//         margin-bottom: -25px;\n//     }\n//     //  @media(max-width: 980px) and (min-width:400px) {\n//     //          margin-left: -65px !important;\n//     //      }\n// }\n\n.msg-box{\n    @include respond-to('small') {\n        margin-top: 10px;\n        margin-left: -35px;\n        width: 325px;\n        font-size: 16px;\n      }\n    \n}\n\n@include respond-to('small') {\n    hr {\n        margin-left: -2px !important;\n        border: 1px solid #979797;\n        width: 266px;\n    }\n}\n\n.review-info-new{\n    // justify-content: space-between;\n    align-items: flex-start;\n    display: flex;\n    max-width: 100%;\n}\n\n.review-info-new .review-block-value {\n    margin-top: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
